import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import "./revealingColumns.scss";

@Component({
    selector: "revealing-columns",
    template: require("./revealingColumns.html")
})
export class RevealingColumnsComponent implements OnInit, OnChanges {

    // Bindings

    @Input() largeColumnSize: number;
    @Input() show: boolean;

    @Output() onSecondColumnClose: EventEmitter<any> = new EventEmitter();

    // Internal

    showSecondColumn: boolean;

    constructor() { }

    ngOnInit() {
        this.setDefaultColumnSize();
    }

    ngOnChanges(changes: SimpleChanges) {
        // When on slower machines this will render the component before animation ensuring smooth animations
        setTimeout(() => {
            this.showSecondColumn = this.show;
        }, 300);

        this.setDefaultColumnSize();
    }

    close() {
        this.show = false;
        this.showSecondColumn = false;
        this.onSecondColumnClose.emit();
    }

    // ---

    private setDefaultColumnSize() {
        if (!this.largeColumnSize || this.largeColumnSize <= 0) {
            this.largeColumnSize = 50;
        }
    }
}
